import * as storage from "../../utils/storage";
import {concat} from "lodash";
import Translate from "../../Atollon/Translation";
import {alertBackendError} from "../../utils/index";
import {getApiPrefix_lagoon} from "../../constants";

function log()
{
    console.log.apply( null, concat( ['%cRequestAttachmentUploader', 'color:#0792ff'], arguments ));
}

export const getHttpRequestDataForFileUploader = ({ requestIdentifier }) =>
{
    const url = `${getApiPrefix_lagoon()}/auth/request/${requestIdentifier}/file`;

    return (
        {
            fileName: "file",
                file: "filename",
            url,
            method: "POST",
            headers: {
            Accept: "application/json",
                Authorization: `Bearer ${storage.get("token")}`
            },
            fields: { transactionId: (new Date()).getTime() }
        }
    );
};

export const onFileUploadedSuccess  = async ({ http: { response, status }, dataForRefresh:{ requestIdentifier, getRequestById }}) =>
{
    // {
    //   id: numberInString,
    //   transactionId: number = OLD MECHANISM DO NOT USE,
    //   uri: string
    // } = response
    log('onFileUploadedSuccess', { response, status, requestIdentifier, getRequestById });

    if( response && response.id )
    {
        // refresh data in views
        getRequestById( requestIdentifier );

        alert( Translate( "Požadavek úspěšně přiložen" ));
    }
    else
    {
        alertBackendError({ response });
        alert( Translate( "Chybně uložený požadavek" ));
    }
};

export const getFileMaskForFileSelection = () =>
{
    const accept = '*.*';
    return accept;
};



// WEBPACK FOOTER //
// ./src/pages/RequestDetail/RequestAttachmentUploader.js